/*
 * @Author: xinxinfeng 2273234784@qq.com
 * @Date: 2024-07-01 14:11:23
 * @LastEditors: xinxinfeng 2273234784@qq.com
 * @LastEditTime: 2026-07-03 15:24:40
 * @FilePath: \crane-safety-manager\src\pages\Dashboard\Top5ProjectsByDailyAbnormalStartups.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Empty } from 'antd';
import moment from 'moment';
import _ from 'lodash';

import usecustomStyles from '../../Common/customStyles';
import * as SThunk from '../../slices/statistics/thunk';

const customStyles = usecustomStyles();

const Top5ProjectsByDailyAbnormalStartups = ({ style, getIdByAbnormalStart }) => {
    // const vehicles = useSelector(state => state.Statistics.dashboard.vehicles);
    const faultyStarts = useSelector(state => state.Statistics.faultyStarts);
    const [topVehicles, setTopVehicles] = useState([]);
    const payload = {
        "startDate": moment().startOf('day').format('YYYY-MM-DD'),
        // "startDate": '2024-07-01',
        "endDate": moment().format('YYYY-MM-DD'),
    }

    const dispatch = useDispatch();
    useEffect(() => {
        // 只有当 faultyStarts 为空对象时才调用 API
        if (!faultyStarts || Object.keys(faultyStarts).length === 0) {
            dispatch(SThunk.faultyStarts(payload));
        }
        // dispatch(SThunk.dashboard());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        let countList = faultyStarts.length > 0 ? [...faultyStarts].sort((a, b) => b.LCount - a.LCount) : [];
        const topList = countList.map((x, i) => (
            <li key={x.name} className='card-list-li' onDoubleClick={()=> getIdByAbnormalStart(x.id,x.name)}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span>
                        <span style={{ margin: '0.5em' }}>{i + 1}.</span> <span>{x.name}</span>
                    </span>{' '}
                    <span>
                        <b style={{ marginRight: '0.5em' }}>{x.LCount} 次</b>
                    </span>
                </div>
            </li>
        ));

        setTopVehicles(topList);
    }, [faultyStarts, getIdByAbnormalStart]);

    const EmptyItem = <Empty image="/nodata.png" description={<span></span>} style={{ padding: '10%' }} />;
    return (
        <Card title="(今日)项目车辆异常启动 - TOP 5" style={style}>
            {topVehicles && topVehicles.length > 0 ? <ul style={{ listStyleType: 'none', padding: 0, height: "15em", overflowY: 'auto' }}>{topVehicles}</ul> : EmptyItem}
        </Card>
    );
};

export default Top5ProjectsByDailyAbnormalStartups;
